const replaceNonDecimal = (value) => {
    let res = value
    if (!/^\d*$/.test(value)) {
        res = value.replace(/\D/g, '')
    }
    return res
}

const formatInput = (value) => {return applyThousandSeperator(reverseThousandCommaSeparation(value))}

const formatInputAndAdjustCursor = (e, value, delay = 10) => {
    var formattedValue = formatInput(value)
    adjustCursorPosition(e, formattedValue, delay)
    return formattedValue
}

function adjustCursorPosition(e, formattedValue, delay = 10) {
    const element = e.target
    const previousCursorPosition = element.selectionStart
    const oldValueLength = element.value.length
    const newValueLength = formattedValue.toString().length

    setTimeout(() => {
        const cursorShift = newValueLength - oldValueLength
        const newCursorPosition = previousCursorPosition + cursorShift

        element.setSelectionRange(newCursorPosition, newCursorPosition)
    }, delay)
}

const applyThousandSeperator = (value) => {
    if (value === null || value === undefined) return ''
    value = value.toString()
    value = value.replace(/[^0-9]/g, '') //remove all non-digit chars
    if (value != '') {
        value = Number(value).toString() //remove prepended zeros
    }
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.') //insert thousand seperator.
    return value
}

const reverseThousandCommaSeparation = (value) => {
    return value.toString().replaceAll('.', '')
}

const replaceFromMap = (map, value) => {
    Object.keys(map).forEach((key) => {
        const replacement = map[key];
        const regex = new RegExp(key, 'g');
        value = value.replace(regex, replacement);
    });

    return value;
}

export {
    replaceNonDecimal,
    formatInput,
    formatInputAndAdjustCursor,
    adjustCursorPosition,
    applyThousandSeperator,
    reverseThousandCommaSeparation,
    replaceFromMap,
}